import { onAddInstitution } from 'redux/configurations/sagas/addInstitutionSaga';
import { savePortalSettings } from 'redux/configurations/sagas/savePortalSettingsSaga';
import { getReminderSettings } from 'redux/configurations/sagas/getReminderSettings';
import { savingReminderSettings, edittingReminderSettings, deletingReminderSettings } from 'redux/configurations/sagas/saveReminderSettings';
import { deletingScheduleSettings, edittingScheduleSettings } from './emailReportScheduleSettingsSaga';
import { saveContactSettings } from 'redux/configurations/sagas/saveContactInfoSaga';
import { getPortalSettings } from 'redux/configurations/sagas/getPortalSettingsSaga';
import { getInstitutionInfo } from 'redux/configurations/sagas/getInstitutionInfoSaga';
import { orgCheck } from 'redux/configurations/sagas/checkOrgSaga';
import { getEmailReportScheduleSettings } from './getEmailReportScheduleSettingsSaga'; 
import { fetchingOrgBranches, savingOrgBranch, edittingOrgBranch, deletingOrgBranch } from './orgBranches'; 
import { call, all } from 'redux-saga/effects';

export default function* institutionSaga() {
  yield all([
    call(onAddInstitution),
    call(savePortalSettings),
    call(saveContactSettings),
    call(getPortalSettings),
    call(getInstitutionInfo),
    call(orgCheck),
    call(getReminderSettings),
    call(savingReminderSettings),
    call(edittingReminderSettings),
    call(deletingReminderSettings),
    call(getEmailReportScheduleSettings),
    call(deletingScheduleSettings),
    call(edittingScheduleSettings),
    call(fetchingOrgBranches),
    call(savingOrgBranch),
    call(edittingOrgBranch),
    call(deletingOrgBranch)
  ]);
}
